import { render, staticRenderFns } from "./WdcCampaignManage.vue?vue&type=template&id=6c9fb978&"
import script from "./WdcCampaignManage.vue?vue&type=script&lang=js&"
export * from "./WdcCampaignManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports